var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHideEye = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9,
    fill: "none",
    viewBox: "0 0 10 9",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0A2540",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88 5.432a1.58 1.58 0 1 1 2.234-2.235M6.553 4.602a1.58 1.58 0 0 1-1.269 1.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.328 6.99C1.534 6.369.862 5.459.375 4.324c.492-1.14 1.169-2.054 1.967-2.682C3.136 1.013 4.052.67 5 .67c.955 0 1.87.347 2.668.98M8.724 2.742c.344.457.647.985.901 1.573C8.642 6.594 6.904 7.966 5 7.966a4 4 0 0 1-1.266-.206M8.944.375 1.057 8.262"
  }))));
};
export default SvgHideEye;